import Vue from 'vue';

Vue.prototype.$urlFileServer = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

Vue.prototype.$checkLocalStore = () => {
  const prueba = 'valor';
  try {
    localStorage.setItem(prueba, prueba);
    localStorage.removeItem(prueba);
    return true;
  } catch (e) {
    return false;
  }
};

Vue.prototype.$normalizacionTexto = (texto) => texto
  .normalize('NFKD').replace(/[\u0300-\u036f]/g, '');

Vue.prototype.$range = (inicio, final) => (
  new Array((final - inicio) + 1)).fill(undefined).map((_, i) => i + inicio);

Vue.prototype.$ejercicioActual = () => Number((new Date()).getFullYear());

Vue.prototype.$scrollTop = () => {
  const element = document.getElementById('app');
  const top = element.offsetTop;
  window.scrollTo(0, top);
};

Vue.prototype.$compararFechas = (fechaUno, fechaDos) => new Date(fechaUno) > new Date(fechaDos);

Vue.prototype.$parseDate = (fecha, split, format) => {
  if (!fecha) return null;

  const [year, mes, dia] = fecha.split(split);
  return `${dia.padStart(2, '0')}${format}${mes.padStart(2, '0')}${format}${year}`;
};

Vue.prototype.$fechaDiffDias = (fechaInicio, fechaTermino) => {
  const nuevaFechaInicio = new Date(`${fechaInicio} 00:00:0`);
  const nuevaFechaTermino = new Date(`${fechaTermino} 00:00:0`);
  // Calcular
  const diferenciaMiliSegundos = Math.abs(nuevaFechaTermino - nuevaFechaInicio);
  const diferenciaDias = Math.ceil(diferenciaMiliSegundos / (1000 * 60 * 60 * 24));

  return (diferenciaDias + 1);
};
Vue.prototype.$fecha = () => ({
  init(fechaMenor, fechaMayor) {
    this.fechaUno = new Date(fechaMenor) || new Date();
    this.fechaDos = new Date(fechaMayor) || new Date();
  },
  comparar() {
    return this.fechaDos > this.fechaUno;
  },
  diffEnDias() {
    if (!this.comparar()) return 0;
    return Number((this.fechaDos - this.fechaUno) / (1000 * 60 * 60 * 24));
  },
  parse(split, format) {
    const [year, mes, dia] = this.fechaUno.split(split);
    return `${dia.padStart(2, '0')}${format}${mes.padStart(2, '0')}${format}${year}`;
  },
  parseEng(fecha) {
    return `${fecha.getFullYear()}-${(fecha.getMonth() + 1)}-${fecha.getDate()}`;
  },
  diasEnUnMes(ejercicio, mes) {
    return new Date(ejercicio, mes, 0).getDate();
  },
  agregarDias(fecha, dias) {
    const resultado = new Date(fecha) || new Date();
    return resultado.setDate(resultado.getDate() + dias);
  },
});

Vue.prototype.$extraerEdad = (fechaNacimiento) => Math
  . floor((new Date() - new Date(fechaNacimiento).getTime()) / 3.15576e+10);

Vue.prototype.$sum = () => ({
  obj(obj, campo) {
    let total = 0;
    if (!Array.isArray(obj)) return 0;
    obj.forEach((item) => {
      total += parseFloat(item[campo]) || 0;
    });

    return total;
  },
  array(obj) {
    if (!obj) return 0;
    return obj.reduce(
      (anterior, actual) => (parseFloat(anterior) || 0) + (parseFloat(actual) || 0),
      0,
    );
  },
});

Vue.prototype.$multiplicar = (a, b) => parseFloat(a) * parseFloat(b);

Vue.prototype.$hasProp = (obj, campo) => campo in obj;

Vue.prototype.$sumarNumerosDosDecimales = (a, b) => Number((`${Math.round(`${(a + b)}e+2`)}e-2`));

Vue.prototype.$restarNumerosDosDecimales = (a, b) => Number((`${Math.round(`${(a - b)}e+2`)}e-2`));

Vue.prototype.$ObjSumar = (obj, campo) => {
  let total = 0;
  if (!Array.isArray(obj)) return 0;

  obj.forEach((item) => {
    total += parseFloat(item[campo]) || 0;
  });

  return Number((`${Math.round(`${total}e+2`)}e-2`));
};

Vue.prototype.$obtenerImporteDosDecimales = (importe) => Number((`${Math.round(`${importe}e+2`)}e-2`));

Vue.prototype.$numberRound = (value) => {
  if (!value) return 0;
  return Number((`${Math.round(`${value}e+2`)}e-2`));
};

Vue.prototype.$numberRoundDigits = (value, digits) => {
  if (!value) return 0;
  return Number((`${Math.round(`${value}e+${digits}`)}e-${digits}`));
};

Vue.prototype.$sumar = (obs) => {
  if (obs) {
    return obs.reduce(
      (anterior, actual) => (parseFloat(anterior) || 0) + (parseFloat(actual) || 0),
      0,
    );
  }
  return 0;
};

Vue.prototype.$archivoValido = (archivo, ext) => {
  const re = /(?:\.([^.]+))?$/;

  if (!archivo) return false;
  if (!ext) return false;

  return re.exec(archivo)[1] === ext;
};

Vue.prototype.$randomColor = () => `#${(`${Math.random().toString(16)}000000`).substring(2, 8)}`;

Vue.prototype.$humanFileSize = (size) => {
  if (size <= 0) return '0B';
  const i = Math.floor(Math.log(size) / Math.log(1024));
  return `${(size / (1024 ** i)).toFixed(2) * 1} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
};

Vue.prototype.$objToArray = (objeto) => Object.keys(objeto).map((item) => {
  const nameKey = {};
  nameKey[item] = objeto[item];
  return nameKey;
});

Vue.prototype.$objToArrKeyName = (objeto, agruparPor) => Object.keys(objeto).map((item) => {
  const nameGroup = {};
  const nameKey = {};
  nameKey[item] = objeto[item];
  nameGroup[agruparPor] = {
    nombre: item,
    grupos: nameKey[item],
  };
  return nameGroup;
});

Vue.prototype.$agruparArray = (arr, prop) => arr.reduce((result, item) => ({
  ...result,
  [item[prop]]:
        [
          ...(result[item[prop]] || []),
          item,
        ],
}),
{});

Vue.prototype.$removerDumplicadosArrayObj = (arr, key) => [...new Map(arr
  .map((item) => [item[key], item])).values()];

Vue.prototype.$inicialesNombre = (nombre) => {
  if (!nombre) return '';
  return nombre.split(' ').map((x) => x.charAt(0)).join('').substr(0, 2)
    .toUpperCase();
};

Vue.prototype.$colorTexto = (hexcolor) => {
  let color = hexcolor;
  // If a leading # is provided, remove it
  if (hexcolor.slice(0, 1) === '#') {
    color = hexcolor.slice(1);
  }

  // If a three-character hexcode, make six-character
  if (hexcolor.length === 3) {
    color = hexcolor.split('').map((hex) => hex + hex).join('');
  }

  // Convert to RGB value
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);

  // Get YIQ ratio
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

  // Check contrast
  return (yiq >= 128) ? 'black' : 'white';
};

// Agregar dias a una fecha
Vue.prototype.$addDias = (fecha, dias) => {
  const resultado = new Date(fecha);
  resultado.setHours(0, 0, 0, 0);
  resultado.setDate(resultado.getDate() + dias);
  return resultado;
};

// Cantidad de dias que tiene un mes
Vue.prototype.$diasDelMes = (fecha) => {
  const date = new Date(fecha);
  return new Date(date.getFullYear(), (date.getMonth() + 1), 0)
    .getDate();
};

// Icono segun extension
Vue.prototype.$iconoDeExtension = (extension) => {
  const iconosDeExtensiones = [
    { extension: 'docx', value: 'fa-file-word' },
    { extension: 'doc', value: 'fa-file-word' },
    { extension: 'xlsx', value: 'fa-file-excel' },
    { extension: 'xls', value: 'fa-file-excel' },
    { extension: 'jpeg', value: 'fa-image' },
    { extension: 'jpg', value: 'fa-image' },
    { extension: 'bmp', value: 'fa-image' },
    { extension: 'png', value: 'fa-image' },
    { extension: 'dwg', value: 'fa-pen-ruler' },
    { extension: 'pdf', value: 'fa-file-pdf' },
  ];

  const extensionBuscar = extension.toLowerCase();
  const extensionIcono = iconosDeExtensiones
    .find((iconoExtension) => iconoExtension.extension === extensionBuscar);

  if (extensionIcono) return extensionIcono.value;

  return 'fa-file';
};
